// TODO: define more properties as we need

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ErrorModel {
    message?: string;
    error?: any;
}
